import React from 'react'
import { SelfRegistrationModal } from './base-modal'
import {
  Typography,
  Divider,
  Box,
  Checkbox,
  FormControlLabel,
  Link
} from '@mui/material'
import { useStyles } from '../style'

export const SelfRegistrationClearAllDomainsModal = ({
  open,
  handleClose,
  handleProceed,
  id
}) => {
  const classes = useStyles()
  const [show, setShow] = React.useState(false)

  const handleModalClose = () => {
    handleClose()

    show && localStorage.setItem(id, 'no')
  }

  const handleSubmit = () => {
    handleProceed()
    handleModalClose()
  }

  return (
    <SelfRegistrationModal
      id={id}
      open={open}
      header={
        <>
          <Typography variant='h6'>Disable Self Registration</Typography>
          <Divider className={classes.divider} />
        </>
      }
      body={
        <>
          <Typography marginBottom={3}>
            All domains have been removed and the whitelist is currently empty.
            If you choose to proceed with this, self-registration will be turned
            off by default.
          </Typography>
          <Typography marginBottom={3}>
            <strong>Remember:</strong> To turn it back on, simply add at least
            one domain to the whitelist.
          </Typography>

          <Typography marginBottom={3}>
            <strong>Note:</strong> Users from the domain you remove will still
            be able to log in
          </Typography>

          <Box marginBottom={3}>
            <FormControlLabel
              control={
                <Checkbox
                  data-test={`${id}-checkbox`}
                  value={show}
                  onChange={() => setShow((state) => !state)}
                />
              }
              label="Don't show this message again"
            />
          </Box>
        </>
      }
      footer={
        <Box className={classes.modalFooterActions}>
          <Link
            underline='hover'
            data-test={`${id}-close-btn`}
            className={classes.modalFooterBtn}
            onClick={handleModalClose}
          >
            Close
          </Link>
          <Link
            underline='hover'
            data-test={`${id}-proceed-btn`}
            className={classes.modalFooterBtn}
            onClick={handleSubmit}
          >
            Proceed
          </Link>
        </Box>
      }
      handleClose={handleClose}
    />
  )
}
